var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"bb-ship"},[_vm._v(_vm._s(_vm.showPrefix)+_vm._s(_vm.ship.name)),(_vm.ship.scale !== 'station')?_c('span',[_vm._v(", "+_vm._s(_vm.ship.shipClass)+" "+_vm._s(_vm.showVet))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3512413c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bbcode/BBShip.vue
// module id = null
// module chunks = 